import Service from '@ember/service';
import { restartableTask, dropTask } from 'ember-concurrency';
import { service } from '@ember/service';
import { queryManager } from 'ember-apollo-client';
import getNotificationsCountQuery from 'my-phorest/gql/queries/notifications-count.graphql';
import leadNotificationsQuery from 'my-phorest/gql/queries/lead-notifications.graphql';
import updateNotificationStatusMutation from 'my-phorest/gql/mutations/update-notification-status.graphql';

export default class LeadNotificationsService extends Service {
  @service session;
  @service apolloSubscriptions;
  @service eventPropagator;

  @queryManager apollo;

  constructor() {
    super(...arguments);
    this.eventPropagator.subscribe(
      'leadNotificationChange',
      this.getNotificationsCountTask.perform
    );
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.eventPropagator.unsubscribe(
      'leadNotificationChange',
      this.getNotificationsCountTask.perform
    );
  }

  @dropTask
  *subscribe() {
    yield this.getLeadNotificationsEnabledTask.perform();
    if (this.isLeadNotificationsEnabled) {
      this.getNotificationsCountTask.perform();
      this.apolloSubscriptions.subscribe('leadNotificationChange');
    }
  }

  unsubscribe() {
    this.apolloSubscriptions.unsubscribe('leadNotificationChange');
    this.getLeadNotificationsEnabledTask.perform();
  }

  get isLeadNotificationsEnabled() {
    return this.getLeadNotificationsEnabledTask.lastSuccessful?.value
      .leadNotificationsEnabled;
  }

  get notificationsCount() {
    if (!this.isLeadNotificationsEnabled) {
      return 0;
    }

    const count =
      this.getNotificationsCountTask.lastSuccessful?.value.notificationsCount
        .count;
    return count > 99 ? '99+' : count;
  }

  @restartableTask
  *getNotificationsCountTask() {
    return yield this.apollo.query({
      query: getNotificationsCountQuery,
      variables: {
        filterBy: {
          type: 'NEW_LEAD',
          status: 'NEW',
        },
      },
      fetchPolicy: 'no-cache',
    });
  }

  @restartableTask
  *getLeadNotificationsEnabledTask() {
    return yield this.apollo.query(
      {
        query: leadNotificationsQuery,
      },
      'leadsSettings'
    );
  }

  @dropTask
  *markNotificationAsSeen(id) {
    if (this.isLeadNotificationsEnabled) {
      yield this.apollo.mutate({
        mutation: updateNotificationStatusMutation,
        variables: {
          id,
          input: {
            status: 'SEEN',
          },
        },
      });
    }
  }
}
